import { HumiHttpErrorResponse } from '@app/classes';

export function extractOverlapErrors(error: HumiHttpErrorResponse): string[] {
    if (!error || !Array.isArray(error.errors)) return [];

    return error.errors.filter((err) => err.source?.pointer?.match(/\.start_time$/)).map((err) => err.detail);
}
